import { useMapContext } from '../../map/MapContext';

export function CoordinatesReadout() {
  const { coordinate, scaleLabel } = useMapContext();

  return (
    <div className="absolute bottom-6 right-6 z-10 flex items-center gap-3 rounded-xl border border-border-default bg-bg-surface px-3.5 py-2 shadow-sm">
      <span className="text-[11px] font-medium text-text-secondary">
        {coordinate ? `${coordinate[1].toFixed(5)}, ${coordinate[0].toFixed(5)}` : '—'}
      </span>
      <span className="h-3 w-px bg-border-default" />
      <span className="text-[11px] font-medium text-text-secondary">{scaleLabel || '—'}</span>
    </div>
  );
}
